import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { SetupForm } from '@/components/forms/SetupForm';
import { Building2, MapPin, Users, TrendingUp } from 'lucide-react';

const Setup = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header siteName="Digital Real Estate" />
      
      {/* Hero Section */}
      <section className="bg-gradient-hero text-white py-20 lg:py-32">
        <div className="container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="animate-slide-up">
              <h1 className="font-display text-4xl lg:text-5xl xl:text-6xl font-bold mb-6 leading-tight">
                Build Your Real Estate Empire Online
              </h1>
              <p className="font-body text-lg text-primary-foreground/80 mb-8 max-w-lg">
                Create a professional real estate website with SEO-optimized town and area pages. Capture leads and grow your business.
              </p>
              <div className="flex flex-wrap gap-6 text-sm font-body">
                <div className="flex items-center gap-2">
                  <Building2 className="h-5 w-5 text-accent" />
                  <span>Custom Branding</span>
                </div>
                <div className="flex items-center gap-2">
                  <MapPin className="h-5 w-5 text-accent" />
                  <span>Town Pages</span>
                </div>
                <div className="flex items-center gap-2">
                  <Users className="h-5 w-5 text-accent" />
                  <span>Lead Capture</span>
                </div>
                <div className="flex items-center gap-2">
                  <TrendingUp className="h-5 w-5 text-accent" />
                  <span>SEO Optimized</span>
                </div>
              </div>
            </div>
            <div className="animate-scale-in">
              <SetupForm />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-background">
        <div className="container">
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-center mb-4">
            Everything You Need to Succeed
          </h2>
          <p className="font-body text-muted-foreground text-center max-w-2xl mx-auto mb-12">
            Our platform provides all the tools to create stunning, SEO-friendly real estate websites.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: MapPin,
                title: 'Town & Area Pages',
                description: 'Generate SEO-optimized pages for every town and neighborhood you serve.',
              },
              {
                icon: Users,
                title: 'Lead Capture',
                description: 'Built-in forms on every page to capture and manage potential clients.',
              },
              {
                icon: TrendingUp,
                title: 'SEO Ready',
                description: 'Automatic sitemaps, meta tags, and structured data for search engines.',
              },
            ].map((feature, index) => (
              <div
                key={index}
                className="p-6 rounded-lg border border-border bg-card hover:shadow-lg transition-shadow duration-300"
              >
                <feature.icon className="h-10 w-10 text-accent mb-4" />
                <h3 className="font-display text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="font-body text-muted-foreground">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer siteName="Digital Real Estate" />
    </div>
  );
};

export default Setup;
